import { render, staticRenderFns } from "./LabelledLensTechSelect.vue?vue&type=template&id=458bfd9d&"
import script from "./LabelledLensTechSelect.vue?vue&type=script&lang=js&"
export * from "./LabelledLensTechSelect.vue?vue&type=script&lang=js&"
import style0 from "./LabelledLensTechSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LensTechSelect: require('/opt/build/repo/storefront/components/molecules/TechSelect/LensTechSelect.vue').default})
